import { createSelector } from '@reduxjs/toolkit';
export const officesReducer = (state) => state.offices;
export const officesSelector = createSelector(officesReducer, (reducer) => {
    return reducer.data;
});
export const sortedOfficesSelector = createSelector(officesSelector, (offices) => {
    const sortedOffices = offices.toSorted((a, b) => a.name.localeCompare(b.name));
    return sortedOffices;
});
export const officeByIdSelector = (officeId) => createSelector(officesSelector, (offices) => {
    return offices.find((office) => office.id === officeId);
});
